module.exports = __webpack_public_path__ + "img/main2.ed4cd303.jpg";